import routes from "../../config/routes";
import { DashboardIcon } from "src/components/icons/dashboard-icon";
import { UserIcon } from "src/components/icons/user-icon";
import { PendingWithdrawalIcon } from "src/components/icons/pending-withdrawal-icon";
import { PendingDepositIcon } from "src/components/icons/pending-deposit-icon";
import { UnidentifiedDepositsIcon } from "src/components/icons/unidentified-deposits-icon";
import { FeeIcon } from "src/components/icons/fee-icon";
import { BankIcon } from "src/components/icons/bank-icon";
import { AdminsIcon } from "src/components/icons/admins-icon";
import { LimitationsIcon } from "src/components/icons/limitations-icon";
import { CurrencyIcon } from "src/components/icons/currency-icon";
import { TransactionHistoryIcon } from "src/components/icons/transaction-history-icon";
import { NotificationIcon } from "src/components/icons/notification-icon";
import { SettingsIcon } from "src/components/icons/settings-icon";
import { OurPricesIcon } from "src/components/icons/our-prices-icon";
import { ArrowUpIcon } from "../../components/icons/arrow-up";
import { ArrowDownIcon } from "../../components/icons/arrow-down";
import { FastTransferIcon } from "../../components/icons/fast-transfer";
import ServiceIcon from "src/components/icons/service-icon";
import { MailboxIcon } from "src/components/icons/mailbox-icon";

export const CODE_EXPIRATION_TIME: number = 60;
export const LIST_PAGE_SIZE: number = 10;

export const BlockMsg =
  "Your account has been blocked, please contact the support for help";
export const NetworkDisconnectMsg =
  "Network is disconnected. Please check your internet connection!";
export const APISomethingWrongMsg =
  "Something went wrong. Please try again later!";

export const desktopOrLaptop = 768;
export const laptop = 1024;
export const macLaptop = 1440;

export const permissions = {
  DASHBOARD: "dashboard",
  USER_MANAGEMENT: "user management",
  PENDING_WITHDRAWALS: "pending withdrawals",
  PENDING_WITHDRAWALS_INDIVIDUAL: "pending_withdrawals_individual",
  PENDING_WITHDRAWALS_BUSINESS: "pending_withdrawals_business",
  PENDING_DEPOSITS: "pending deposits",
  PENDING_DEPOSIT_INDIVIDUAL: "pending_deposit_individual",
  PENDING_DEPOSIT_BUSINESS: "pending_deposit_business",
  TRANSACTIONS: "transactions",
  TRANSACTION_HISTORY_INDIVIDUAL: "transaction_history_individual",
  TRANSACTION_HISTORY_BUSINESS: "transaction_history_business",
  TRANSACTION_HISTORY_NEW_INDIVIDUAL: "transaction_history_new_individual",
  TRANSACTION_HISTORY_NEW_BUSINESS: "transaction_history_new_business",
  EXPORT_HISTORY: "export history",
  FEE_MANAGEMENT: "fee management",
  FEE_MANAGEMENT_INDIVIDUAL: "fee_management_individual",
  FEE_MANAGEMENT_BUSINESS: "fee_management_business",
  MONEY_MOVER: "manage moneymover",
  MONEY_MOVER_CATEGORIES: "money_movers_categories",
  MONEY_MOVER_SERVICES: "money_movers_services",
  MONEY_MOVER_CASINO_CASHOUT: "money_movers_casino_cashout",
  MANAGE_CHANNEL_PARTNERS: "channel_partner",
  PERMISSIONS: "Permissions",
  ROLES_PERMISSIONS: "roles_permission",
  MANAGE_ROLES_PERMISSIONS: "Manage Roles Permission",
  ADMIN_MANAGEMENT: "admin management",
  LIMITATIONS: "limitations",
  LIMITATIONS_INDIVIDUAL: "limitations_individual",
  LIMITATION_BUSINESS: "limitation_business",
  LIMITATIONS_MONEY_MOVERS_INDIVIDUAL: "limitations_money_movers_individual",
  LIMITATIONS_MONEY_MOVERS_BUSINESS: "limitations_money_movers_business",
  CURRENCY: "currency",
  NOTIFICATIONS: "notifications",
  ADMIN_ALERT: "admin notification",
  EMAIL_TEMP: "email template",
  SETTINGS: "settings",
  USER_MANAGEMENT_INDIVIDUAL_USERS: "user_management_individual_users",
  USER_MANAGEMENT_BUSINESS_USERS: "user_management_business_users",
  USER_MANAGEMENT_2FA_RESET_REQUEST: "user_management_2fa_reset_request",
  USER_MANAGEMENT_EMAIL: "user_management_email",
  USER_MANAGEMENT_SMS: "user_management_sms",
  UPDATE_USER_2FA_STATUS_METHOD: "update_user_2fa_status_method",
  INDIVIDUAL_USERS: "individual users",
  BUSINESS_USERS: "business users",
  OUR_PRICES: "our prices",
  BANK_ACCOUNTS: "bank accounts",
  MANAGE_UNIDENTIFIED_DEPOSITS: "manage unidentified deposits",
  RESET_2FA: "manage 2fa resets",
  SMS_2FA: "sms 2fa history",
  EMAIL_2FA: "email 2fa history",
  TRANSLATION: "manage translation",
  // TRANSLATION_BACKEND: "translation_backend",
  // TRANSLATION_MOBILE: "translation_mobile",
  // TRANSLATION_WEB: "translation_web",
  TRANSLATION_BACKEND: "manage translation",
  TRANSLATION_MOBILE: "manage translation",
  TRANSLATION_WEB: "manage translation",
  CONVERSION: "manage conversion",
  SELF_TERMINAL: "manage terminal provider",
  WALLET_TERMINAL: "manage wallet terminal",
  GUEST_USER: "manage guest user",
  MANAGE_ADMIN: "admin activity",
  ACTIVITY_LOGS: "activity_logs",
  ADMIN_MANUAL_TRANSACTION: "admin transaction",
  MANUAL_TRANSACTIONS_INDIVIDUAL: "manual_transactions_individual",
  MANUAL_TRANSACTIONS_BUSINESS: "manual_transactions_business",
  SERVICE_MAINTENANCE: "service-maintenance",
  // SERVICE_ALERTS: "alert-service",
  SERVICE_MAINTENANCES: "service_maintenances",
  SERVICE_ALERTS: "service_alerts",
  SERVICE_INCIDENTS: "service_incidents",
  MANAGE_SERVICES: "manage services",
  KYC_INFO: "kyc_info",
  CARD_MANAGEMENT: "card-management",
  CARD_KAFKA_SYNC_HISTORY: "card_kafka_sync_history",
  CARD_PRODUCTS: "card_products",
  CARD_DESIGN: "card_design",
  CARD_TERMS_CONDITIONS: "card_terms_conditions",
  CARD_MERCHANTS: "card_merchants",
  CARD_CONVERSION_RATES: "card_conversion_rates",
  CARD_CONVERSION_RATES_HISTORY: "card_conversion_rates_history",
  CARD_TRANSACTIONS: "card_transactions",
  CARD_POOL: "card_pool",
  ORDERED_CARDS_HISTORY: "ordered_cards_history",
  CARD_KAFKA_NOTIFICATION: "card_kafka_notification",
  CARD_BILLINGS: "card_billings",
  LANDING_PAGE: "landing-page",
  LANDING_PAGE_MANAGEMENT_BLOG_POSTS: "landing_page_management_blog_posts",
  LANDING_PAGE_MANAGEMENT_FAQ: "landing_page_management_faq",
  VIRTUAL_CARD_MANAGEMENT: "virtual_card_management",
};

export const FullSidebarMenus = [
  {
    orderId: 1,
    permission: permissions.DASHBOARD,
    title: "Dashboard",
    link: routes.dashboard,
    icon: <DashboardIcon className="h-[20px] w-[20px] text-secondary" />,
    activeIcon: <DashboardIcon className="h-[20px] w-[20px] text-primary" />,
  },
  {
    orderId: 2,
    permission: [
      permissions.USER_MANAGEMENT_INDIVIDUAL_USERS,
      permissions.USER_MANAGEMENT_BUSINESS_USERS,
      permissions.USER_MANAGEMENT_2FA_RESET_REQUEST,
      permissions.USER_MANAGEMENT_EMAIL,
      permissions.USER_MANAGEMENT_SMS,
    ],
    title: "User Management",
    link: routes.users,
    icon: <UserIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowUpIcon: <ArrowUpIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowDownIcon: (
      <ArrowDownIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    activeIcon: <UserIcon className="h-[20px] w-[20px] text-primary" />,
    subMenu: [
      {
        permission: permissions.USER_MANAGEMENT_INDIVIDUAL_USERS,
        title: "Individual",
        link: routes.users,
      },
      {
        permission: permissions.USER_MANAGEMENT_BUSINESS_USERS,
        title: "Business",
        link: routes.usersBusiness,
      },
      // {
      //   title: "Exports list",
      //   permission: permissions.EXPORT_HISTORY,
      //   link: routes.exportsList,
      // },
      {
        permission: permissions.USER_MANAGEMENT_2FA_RESET_REQUEST,
        title: "2FA reset request",
        link: routes.reset2FA,
      },
      {
        permission: permissions.USER_MANAGEMENT_EMAIL,
        title: "Email",
        link: routes.emailHistory,
      },
      {
        permission: permissions.USER_MANAGEMENT_SMS,
        title: "SMS",
        link: routes.smsHistory,
      },
    ],
  },
  {
    orderId: 3,
    permission: [
      permissions.TRANSACTION_HISTORY_INDIVIDUAL,
      permissions.TRANSACTION_HISTORY_BUSINESS,
      permissions.TRANSACTION_HISTORY_NEW_INDIVIDUAL,
      permissions.TRANSACTION_HISTORY_NEW_BUSINESS,
    ],
    title: "Transactions History",
    link: routes.transactions,
    icon: (
      <TransactionHistoryIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    arrowUpIcon: <ArrowUpIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowDownIcon: (
      <ArrowDownIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    activeIcon: (
      <TransactionHistoryIcon className="h-[20px] w-[20px] text-primary" />
    ),
    subMenu: [
      {
        title: "Individual",
        permission: permissions.TRANSACTION_HISTORY_INDIVIDUAL,
        link: routes.transactions,
      },
      {
        title: "Business",
        permission: permissions.TRANSACTION_HISTORY_BUSINESS,
        link: routes.transactionsBusiness,
      },
      {
        title: "New Individual",
        permission: permissions.TRANSACTION_HISTORY_NEW_INDIVIDUAL,
        link: routes.updatedtransactions,
      },
      {
        title: "New Business",
        permission: permissions.TRANSACTION_HISTORY_NEW_BUSINESS,
        link: routes.updatedtransactionsBusiness,
      },

      // {
      //   title: "Exports list",
      //   permission: permissions.TRANSACTIONS,
      //   link: routes.exportsList,
      // },
    ],
  },
  {
    orderId: 28,
    permission: permissions.EXPORT_HISTORY,
    title: "Exports list",
    link: routes.exportsList,
    icon: (
      <TransactionHistoryIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    activeIcon: (
      <TransactionHistoryIcon className="h-[20px] w-[20px] text-primary" />
    ),
  },

  {
    orderId: 22,
    permission: [
      permissions.MANUAL_TRANSACTIONS_INDIVIDUAL,
      permissions.MANUAL_TRANSACTIONS_BUSINESS,
    ],
    title: "Manual Transactions",
    link: routes.individualmanualTransfers,
    icon: (
      <TransactionHistoryIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    arrowUpIcon: <ArrowUpIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowDownIcon: (
      <ArrowDownIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    activeIcon: (
      <TransactionHistoryIcon className="h-[20px] w-[20px] text-primary" />
    ),
    subMenu: [
      {
        permission: permissions.MANUAL_TRANSACTIONS_INDIVIDUAL,
        title: "Individual",
        link: routes.individualmanualTransfers,
      },
      {
        permission: permissions.MANUAL_TRANSACTIONS_BUSINESS,
        title: "Business",
        link: routes.businessmanualTransfers,
      },
    ],
  },
  {
    orderId: 4,
    permission: [
      permissions.PENDING_WITHDRAWALS_INDIVIDUAL,
      permissions.PENDING_WITHDRAWALS_BUSINESS,
    ],
    title: "Pending Withdrawals",
    link: routes.pendingWithdrawals,
    arrowUpIcon: <ArrowUpIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowDownIcon: (
      <ArrowDownIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    icon: (
      <PendingWithdrawalIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    activeIcon: (
      <PendingWithdrawalIcon className="h-[20px] w-[20px] text-primary" />
    ),
    subMenu: [
      {
        title: "Individual",
        permission: permissions.PENDING_WITHDRAWALS_INDIVIDUAL,
        link: routes.pendingWithdrawals,
      },
      {
        title: "Business",
        permission: permissions.PENDING_WITHDRAWALS_BUSINESS,
        link: routes.pendingWithdrawalsBuisiness,
      },
    ],
  },
  {
    orderId: 5,
    permission: permissions.MANAGE_UNIDENTIFIED_DEPOSITS,
    title: "Unidentified deposit",
    link: routes.unidentifiedDeposits,
    icon: (
      <UnidentifiedDepositsIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    activeIcon: (
      <UnidentifiedDepositsIcon className="h-[20px] w-[20px] text-primary" />
    ),
  },
  {
    orderId: 6,
    permission: [
      permissions.PENDING_DEPOSIT_INDIVIDUAL,
      permissions.PENDING_DEPOSIT_BUSINESS
    ],
    title: "Pending Deposit",
    link: routes.pendingDeposit,
    arrowUpIcon: <ArrowUpIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowDownIcon: (
      <ArrowDownIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    icon: <PendingDepositIcon className="h-[20px] w-[20px] text-secondary" />,
    activeIcon: (
      <PendingDepositIcon className="h-[20px] w-[20px] text-primary" />
    ),
    subMenu: [
      {
        title: "Individual",
        permission: permissions.PENDING_DEPOSIT_INDIVIDUAL,
        link: routes.pendingDeposit,
      },
      {
        title: "Business",
        permission: permissions.PENDING_DEPOSIT_BUSINESS,
        link: routes.pendingDepositBuisiness,
      },
    ],
  },
  {
    orderId: 7,
    permission: permissions.OUR_PRICES,
    title: "Our prices",
    link: routes.ourPrices,
    icon: <OurPricesIcon className="h-[20px] w-[20px] text-secondary" />,
    activeIcon: <OurPricesIcon className="h-[20px] w-[20px] text-primary" />,
  },
  {
    orderId: 8,
    title: "Fee Management",
    permission: [
      permissions.FEE_MANAGEMENT_INDIVIDUAL,
      permissions.FEE_MANAGEMENT_BUSINESS,
    ],
    link: routes.feeManagement,
    arrowUpIcon: <ArrowUpIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowDownIcon: (
      <ArrowDownIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    icon: <FeeIcon className="h-[20px] w-[20px] text-secondary" />,
    activeIcon: <FeeIcon className="h-[20px] w-[20px] text-primary" />,
    subMenu: [
      {
        title: "Individual",
        permission: permissions.FEE_MANAGEMENT_INDIVIDUAL,
        link: routes.feeManagement,
      },
      {
        title: "Business",
        permission: permissions.FEE_MANAGEMENT_BUSINESS,
        link: routes.feeManagementBusiness,
      },
    ],
  },
  {
    orderId: 9,
    title: "Money Movers",
    permission: [
      permissions.MONEY_MOVER_CATEGORIES,
      permissions.MONEY_MOVER_SERVICES,
      permissions.MONEY_MOVER_CASINO_CASHOUT,
    ],
    link: routes.moneyMoverCategories,
    arrowUpIcon: <ArrowUpIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowDownIcon: (
      <ArrowDownIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    icon: <FeeIcon className="h-[20px] w-[20px] text-secondary" />,
    activeIcon: <FeeIcon className="h-[20px] w-[20px] text-primary" />,
    subMenu: [
      {
        title: "Categories",
        permission: permissions.MONEY_MOVER_CATEGORIES,
        link: routes.moneyMoverCategories,
      },
      {
        title: "Services",
        permission: permissions.MONEY_MOVER_SERVICES,
        link: routes.moneyMoverServices,
      },
      {
        title: "Casino Cashout",
        permission: permissions.MONEY_MOVER_CASINO_CASHOUT,
        link: routes.moneyMoverCasinoServices,
      },
    ],
  },
  // {
  //   orderId: 11,
  //   permission: permissions.ADMIN_MANAGEMENT,
  //   title: "Admin Management",
  //   link: routes.admins,
  //   icon: <AdminsIcon className="h-[20px] w-[20px] text-secondary" />,
  //   activeIcon: <AdminsIcon className="h-[20px] w-[20px] text-primary" />,
  // },
  {
    orderId: 11.2,
    permission: permissions.ADMIN_MANAGEMENT,
    title: "Manage Admin",
    link: routes.adminManageWhiteLabel,
    icon: <AdminsIcon className="h-[20px] w-[20px] text-secondary" />,
    activeIcon: <AdminsIcon className="h-[20px] w-[20px] text-primary" />,
  },

  {
    orderId: 11.5,
    permission: [
      permissions.ROLES_PERMISSIONS,
      permissions.PERMISSIONS
    ],
    title: "Manage Roles Permission",
    link: routes.roles,
    icon: <UserIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowUpIcon: <ArrowUpIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowDownIcon: (
      <ArrowDownIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    activeIcon: <UserIcon className="h-[20px] w-[20px] text-primary" />,
    subMenu: [
      {
        permission: permissions.ROLES_PERMISSIONS,
        title: "Roles Permission",
        link: routes.roles,
      },
      {
        permission: permissions.PERMISSIONS,
        title: "Permissions",
        link: routes.permissions,
      },
    ],
  },
  {
    orderId: 11.6,
    permission: permissions.MANAGE_CHANNEL_PARTNERS,
    title: "Manage Channel Partners",
    link: routes.channelPartners,
    icon: <UserIcon className="h-[20px] w-[20px] text-secondary" />,
    activeIcon: <UserIcon className="h-[20px] w-[20px] text-primary" />,
  },

  {
    orderId: 12,
    permission: [
      permissions.LIMITATIONS_INDIVIDUAL,
      permissions.LIMITATION_BUSINESS,
      permissions.LIMITATIONS_MONEY_MOVERS_INDIVIDUAL,
      permissions.LIMITATIONS_MONEY_MOVERS_BUSINESS,
    ],
    title: "Limitations",
    link: routes.limitations,
    icon: <LimitationsIcon className="h-[20px] w-[20px] text-secondary" />,
    activeIcon: <LimitationsIcon className="h-[20px] w-[20px] text-primary" />,
    arrowUpIcon: <ArrowUpIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowDownIcon: (
      <ArrowDownIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    subMenu: [
      {
        title: "Individual",
        permission: permissions.LIMITATIONS_INDIVIDUAL,
        link: routes.limitations,
        activeIcon: (
          <LimitationsIcon className="h-[20px] w-[20px] text-primary" />
        ),
      },
      {
        title: "Business",
        permission: permissions.LIMITATION_BUSINESS,
        link: routes.limitationsBusiness,
      },
      {
        title: "Money Movers Individual",
        permission: permissions.LIMITATIONS_MONEY_MOVERS_INDIVIDUAL,
        link: routes.limitationsMoneyMoversIndividual,
      },
      {
        title: "Money Movers Business",
        permission: permissions.LIMITATIONS_MONEY_MOVERS_BUSINESS,
        link: routes.limitationsMoneyMoversBusiness,
      },
    ],
  },
  {
    orderId: 13,
    permission:
      [
        permissions.NOTIFICATIONS,
        permissions.ADMIN_ALERT,
        permissions.EMAIL_TEMP,
      ],
    title: "Notification",
    link: routes.notification,
    icon: <NotificationIcon className="h-[20px] w-[20px] text-secondary" />,
    activeIcon: <NotificationIcon className="h-[20px] w-[20px] text-primary" />,
    arrowUpIcon: <ArrowUpIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowDownIcon: (
      <ArrowDownIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    subMenu: [
      {
        title: "User Notifications",
        permission: permissions.NOTIFICATIONS,
        link: routes.notification,
      },
      {
        title: "Admin Alerts",
        permission: permissions.ADMIN_ALERT,
        link: routes.adminAlerts,
      },
      {
        title: "Email Templates",
        permission: permissions.EMAIL_TEMP,
        link: routes.emailTemplate,
      },
    ],
  },
  // {
  //   orderId: 14,
  //   title: "Fast international money transfers",
  //   link: routes.fastTransfer,
  //   icon: <FastTransferIcon className="h-[20px] w-[20px] text-secondary" />,
  //   activeIcon: <FastTransferIcon className="h-[20px] w-[20px] text-primary" />,
  // },
  {
    orderId: 15,
    permission: permissions.BANK_ACCOUNTS,
    title: "Bank Account",
    link: routes.bankAccounts,
    icon: <BankIcon className="h-[20px] w-[20px] text-secondary" />,
    activeIcon: <BankIcon className="h-[20px] w-[20px] text-primary" />,
  },
  {
    orderId: 16,
    permission: permissions.CURRENCY,
    title: "Currency",
    link: routes.currency,
    icon: <CurrencyIcon className="h-[20px] w-[20px] text-secondary" />,
    activeIcon: <CurrencyIcon className="h-[20px] w-[20px] text-primary" />,
  },
  // {
  //   orderId: 17,
  //   permission: permissions.SETTINGS,
  //   title: "Settings",
  //   link: routes.settings,
  //   icon: <SettingsIcon className="h-[20px] w-[20px] text-secondary" />,
  //   activeIcon: <SettingsIcon className="h-[20px] w-[20px] text-primary" />,
  // },
  {
    orderId: 18,
    permission: [
      permissions.TRANSLATION_BACKEND,
      permissions.TRANSLATION_MOBILE,
      permissions.TRANSLATION_WEB
    ],
    title: "Translation",
    link: routes.translation,
    icon: <AdminsIcon className="h-[20px] w-[20px] text-secondary" />,
    activeIcon: <AdminsIcon className="h-[20px] w-[20px] text-primary" />,
    arrowUpIcon: <ArrowUpIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowDownIcon: (
      <ArrowDownIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    subMenu: [
      {
        title: "Web",
        permission: permissions.TRANSLATION_WEB,
        link: routes.translation,
        activeIcon: (
          <LimitationsIcon className="h-[20px] w-[20px] text-primary" />
        ),
      },
      {
        title: "Mobile",
        permission: permissions.TRANSLATION_MOBILE,
        link: routes.mobileTranslation,
      },
      {
        title: "Backend",
        permission: permissions.TRANSLATION_BACKEND,
        link: routes.backendTranslation,
      },
    ],
  },
  {
    orderId: 19,
    permission: permissions.CONVERSION,
    title: "Conversion",
    link: routes.Conversion,
    icon: <AdminsIcon className="h-[20px] w-[20px] text-secondary" />,
    activeIcon: <AdminsIcon className="h-[20px] w-[20px] text-primary" />,
  },
  {
    orderId: 20,
    permission: permissions.SELF_TERMINAL,
    title: "Self Terminal",
    link: routes.users,
    icon: <UserIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowUpIcon: <ArrowUpIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowDownIcon: (
      <ArrowDownIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    activeIcon: <UserIcon className="h-[20px] w-[20px] text-primary" />,
    subMenu: [
      {
        permission: permissions.SELF_TERMINAL,
        title: "Provider",
        link: routes.provider,
      },
      {
        permission: permissions.SELF_TERMINAL,
        title: "Transactions",
        link: routes.providerTransaction,
      },
    ],
  },
  {
    orderId: 23,
    permission: permissions.WALLET_TERMINAL,
    title: "Manage Wallet Terminal",
    link: routes.walletTerminal,
    icon: <UserIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowUpIcon: <ArrowUpIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowDownIcon: (
      <ArrowDownIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    activeIcon: <UserIcon className="h-[20px] w-[20px] text-primary" />,
    subMenu: [
      {
        permission: permissions.WALLET_TERMINAL,
        title: "Wallet Terminal ",
        link: routes.walletTerminal,
      },
      {
        permission: permissions.WALLET_TERMINAL,
        title: "MTS transfer logs",
        link: routes.mtsTransferLogs,
      },
    ],
  },
  {
    orderId: 21,
    permission: [
      permissions.MANAGE_ADMIN,
      permissions.ACTIVITY_LOGS,
    ],
    title: "Manage Admin Activities",
    link: routes.adminActivity,
    icon: <UserIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowUpIcon: <ArrowUpIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowDownIcon: (
      <ArrowDownIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    activeIcon: <UserIcon className="h-[20px] w-[20px] text-primary" />,
    subMenu: [
      {
        permission: permissions.MANAGE_ADMIN,
        title: "Admin activity",
        link: routes.adminActivity,
      },
      {
        permission: permissions.ACTIVITY_LOGS,
        title: "Activity logs",
        link: routes.activityLogs,
      },
    ],
  },
  {
    orderId: 24,
    permission: [
      permissions.SERVICE_MAINTENANCES,
      permissions.SERVICE_ALERTS,
      permissions.SERVICE_INCIDENTS,
    ],
    title: "Manage Services",
    link: routes.serviceMaintenance,
    icon: <ServiceIcon className="h-[20px] w-[20px] text-secondary" />,
    activeIcon: <ServiceIcon className="h-[20px] w-[20px] text-primary" />,
    arrowUpIcon: <ArrowUpIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowDownIcon: (
      <ArrowDownIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    subMenu: [
      {
        permission: permissions.SERVICE_MAINTENANCES,
        title: "Service Maintenance",
        link: routes.serviceMaintenance,
      },
      {
        permission: permissions.SERVICE_ALERTS,
        title: "Service Alerts",
        link: routes.serviceAlerts,
      },
      {
        permission: permissions.SERVICE_INCIDENTS,
        title: "Service Incidents",
        link: routes.serviceIncidents,
      },
    ],
  },
  {
    orderId: 26,
    permission: [
      permissions.CARD_PRODUCTS,
      permissions.CARD_DESIGN,
      permissions.CARD_TERMS_CONDITIONS,
      permissions.CARD_MERCHANTS,
      permissions.CARD_CONVERSION_RATES,
      permissions.CARD_CONVERSION_RATES_HISTORY,
      permissions.CARD_TRANSACTIONS,
      permissions.CARD_POOL,
      permissions.ORDERED_CARDS_HISTORY,
      permissions.CARD_KAFKA_NOTIFICATION,
      permissions.CARD_BILLINGS,
      permissions.CARD_KAFKA_SYNC_HISTORY,
    ],
    title: "Card Management",
    link: routes.cardPackages,
    icon: <BankIcon className="h-[20px] w-[20px] text-secondary" />,
    activeIcon: <BankIcon className="h-[20px] w-[20px] text-primary" />,
    arrowUpIcon: <ArrowUpIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowDownIcon: (
      <ArrowDownIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    subMenu: [
      {
        permission: permissions.CARD_PRODUCTS,
        title: "Card Products",
        link: routes.cardProducts,
      },
      {
        permission: permissions.CARD_DESIGN,
        title: "Card Design",
        link: routes.cardTypes,
      },
      {
        permission: permissions.CARD_TERMS_CONDITIONS,
        title: "Card Terms & Conditions",
        link: routes.cardTermsConditions,
      },
      {
        permission: permissions.CARD_MERCHANTS,
        title: "Card Merchants",
        link: routes.cardMerchants,
      },
      {
        permission: permissions.CARD_CONVERSION_RATES,
        title: "Conversion Rates",
        link: routes.cardConversionList,
      },
      {
        permission: permissions.CARD_CONVERSION_RATES_HISTORY,
        title: "Conversion Rates History",
        link: routes.cardConversionSyncHistory,
      },
      {
        permission: permissions.CARD_TRANSACTIONS,
        title: "Card Transactions",
        link: routes.cardAllTransactions,
      },
      {
        permission: permissions.CARD_POOL,
        title: "Card Pool",
        link: routes.cardPool,
      },
      {
        permission: permissions.ORDERED_CARDS_HISTORY,
        title: "Ordered Cards History",
        link: routes.orderedCardHistory,
      },
      {
        permission: permissions.CARD_KAFKA_NOTIFICATION,
        title: "Kafka Notifications",
        link: routes.kafkaNotifications,
      },
      {
        permission: permissions.CARD_BILLINGS,
        title: "Card Billings",
        link: routes.cardBillings,
      },
      {
        permission: permissions.CARD_KAFKA_SYNC_HISTORY,
        title: "Kafka sync history",
        link: routes.kafkaSyncHistory,
      },
    ],
  },
  {
    orderId: 27,
    permission: [
      permissions.LANDING_PAGE_MANAGEMENT_FAQ,
      permissions.LANDING_PAGE_MANAGEMENT_BLOG_POSTS,
    ],
    title: "Landing Page Management",
    link: routes.manageFaqs,
    icon: <BankIcon className="h-[20px] w-[20px] text-secondary" />,
    activeIcon: <BankIcon className="h-[20px] w-[20px] text-primary" />,
    arrowUpIcon: <ArrowUpIcon className="h-[20px] w-[20px] text-secondary" />,
    arrowDownIcon: (
      <ArrowDownIcon className="h-[20px] w-[20px] text-secondary" />
    ),
    subMenu: [
      // {
      //   permission: permissions.CARD_MANAGEMENT,
      //   title: "Card Packages",
      //   link: routes.cardPackages,
      // },
      {
        permission: permissions.LANDING_PAGE_MANAGEMENT_FAQ,
        title: "FAQ's",
        link: routes.manageFaqs,
      },
      {
        permission: permissions.LANDING_PAGE_MANAGEMENT_BLOG_POSTS,
        title: "Blog Posts",
        link: routes.manageBlogs,
      },
    ],
  },
  // {
  //   orderId: 25,
  //   permission: permissions.SERVICE_ALERTS,
  //   title: "Service Alerts",
  //   link: routes.serviceAlerts,
  //   icon: <ServiceIcon className="h-[20px] w-[20px] text-secondary" />,
  //   activeIcon: <ServiceIcon className="h-[20px] w-[20px] text-primary" />,
  // },
  // {
  //   orderId: 23,
  //   permission: permissions.MANAGE_ADMIN,
  //   title: "Manage Activity logs",
  //   link: routes.activityLogs,
  //   icon: <UserIcon className="h-[20px] w-[20px] text-secondary" />,
  //   activeIcon: <UserIcon className="h-[20px] w-[20px] text-primary" />,
  // },
];

export const TransactionType = [
  {
    id: 1,
    name: "All",
    code: "all",
    active: 1,
  },
  {
    id: 2,
    name: "Deposit",
    code: "deposit",
    active: 1,
  },
  {
    id: 3,
    name: "Withdrawal",
    code: "withdraw",
    active: 1,
  },
];

export enum SUCCESS_MODAL_TYPE {
  ChangePassword = "change_password",
  KYC = "kyc",
  ForgotPassword = "forgot_password",
  EmailVerification = "email_verification",
  ExternaTransfer = "external_transfer",
}

export enum PAYMENT_TYPE {
  Deposit = "deposit",
  Withdrawal = "withdrawal",
}

export enum PAYMENT_OPTIONS {
  Paypal = "paypal",
  Bank = "bank_transfer",
  Card = "cartubank",
  Fts = "fts",
}

export const userManagementFilterOptions = [
  {
    code: "",
    name: "All",
  },
  {
    code: "level",
    name: "Level",
  },
  {
    code: "risk_level",
    name: "Risk Level",
  },
  {
    code: "status",
    name: "Status",
  },
  {
    code: "user_type",
    name: "User type",
  },
  {
    code: "user_id",
    name: "User ID",
  },
  {
    code: "full_name",
    name: "Full name",
  },
  {
    code: "phone",
    name: "Phone",
  },
  {
    code: "email",
    name: "Email",
  },
  {
    code: "personal_number",
    name: "Personal Number",
  },
  {
    code: "payment_reference",
    name: "Reference number",
  },
];

export const userManagementFilterOptions_1 = [
  {
    code: "user_id",
    name: "User ID",
  },
  {
    code: "full_name",
    name: "Full name",
  },
  {
    code: "phone",
    name: "Phone",
  },
  {
    code: "email",
    name: "Email",
  },
  // {
  //   code: "country",
  //   name: "Country",
  // },
];

export const adminManagementFilterOptions = [
  {
    code: "user_id",
    name: "User ID",
  },
  {
    code: "model",
    name: "Model",
  },
];

export const emailTemplateFilterOptions = [
  {
    code: "type",
    name: "Type",
  },
  {
    code: "template_type",
    name: "Template type",
  },
  {
    code: "email_type",
    name: "Notification type",
  },
  {
    code: "subject",
    name: "Subject",
  },
];

export const adminLogsFilterOptions = [
  // {
  //   code: "admin_id",
  //   name: "Admin ID",
  // },
  {
    code: "type",
    name: "Type",
  },
  {
    code: "ip_address",
    name: "IP",
  },
];
export const adminLogsAdminIdFilter = [
  {
    code: "admin_id",
    name: "Admin ID",
  },
];

export const transactionFilterOptions = [
  {
    code: "currency",
    name: "Currency",
  },
  {
    code: "fee",
    name: "Fee",
  },
  {
    code: "amount",
    name: "Amount",
  },
  {
    code: "payment_system",
    name: "Payment method",
  },
  {
    code: "status",
    name: "Status",
  },
  {
    code: "full_name",
    name: "Name",
  },
  {
    code: "user_id",
    name: "User ID",
  },
  {
    code: "payment_reference",
    name: "Reference",
  },
];

export const manualTransferFilterOptions = [
  {
    code: "user_id",
    name: "User Id",
  },
  {
    code: "type",
    name: "Type",
  },
  {
    code: "status",
    name: "Status",
  },
  // {
  //   code: "to_user_id",
  //   name: "Receiver Id",
  // },
];
export const w2wTransactionFilterOptions = [
  {
    code: "from_user_id",
    name: "Sender Id",
  },
  {
    code: "to_user_id",
    name: "Receiver Id",
  },
  {
    code: "amount",
    name: "Amount",
  },
  {
    code: "receiver_name",
    name: "Receiver name",
  },
  {
    code: "sender_name",
    name: "Sender name",
  },
];

export const walletTerminalTransactionFilterOptions = [
  {
    code: "user_id",
    name: "User Id",
  },
  {
    code: "provider_transaction_ref",
    name: "Provider Transaction ID",
  },
  {
    code: "amount",
    name: "Amount",
  },

  {
    code: "type",
    name: "Type",
  },
  {
    code: "status",
    name: "Status",
  },
];
export const conversionFilterOptions = [
  {
    code: "amount",
    name: "Amount",
  },
  {
    code: "full_name",
    name: "Name",
  },
  {
    code: "user_id",
    name: "User ID",
  },
];

export const pendingWithdrawalFilterOptions = [
  {
    code: "user_id",
    name: "User ID",
  },
  {
    code: "currency",
    name: "Currency",
  },
  {
    code: "amount",
    name: "Amount",
  },
  {
    code: "payment_system",
    name: "Payment method",
  },
];

export const kwickpayTransactionsFilterOptions = [
  {
    code: "status",
    name: "Status",
  },
  {
    code: "user_id",
    name: "User ID",
  },
  {
    code: "currency",
    name: "Currency",
  },
  {
    code: "deposit_method",
    name: "Deposit method",
  },
  {
    code: "amount",
    name: "Amount",
  },
  {
    code: "sender_name",
    name: "Sender name",
  },
  {
    code: "sender_country",
    name: "Sender country",
  },
];

export const billingTransactionsFilterOptions = [
  {
    code: "status",
    name: "Status",
  },
];

export const billingTransactionSearchOptions = [];
// 0 Other Bank | 1 Partner Bank | 2 Paysera Sepa | 3 Paysera Iban
export const bankTypeOptions = [
  {
    value: 3,
    label: "Paysera Iban",
  },
  {
    value: 2,
    label: "Paysera Sepa",
  },
  {
    value: 1,
    label: "Partner Bank",
  },
  {
    value: 0,
    label: "Other bank",
  },
];

export const unidentDepositFilterOptions = [
  {
    code: "external_payment_id",
    name: "External payment ID",
  },
  {
    code: "user_id",
    name: "User ID",
  },
  {
    code: "payment_id",
    name: "Payment ID",
  },
  {
    code: "admin_id",
    name: "Admin ID",
  },
  {
    code: "sender_name",
    name: "Sender name",
  },
  {
    code: "status",
    name: "Status",
  },
  {
    code: "asset_id",
    name: "Currency",
  },
  {
    code: "external_processing_system",
    name: "Payment method",
  },
  {
    code: "sender_bank_name",
    name: "Bank name",
  },
  {
    code: "sender_iban",
    name: "IBAN",
  },
];

export const reset2faFilterOptions = [
  {
    code: "user_id",
    name: "User ID",
  },
  {
    code: "email",
    name: "Email",
  },
];

export const emailHistoryFilterOptions = [
  {
    code: "user_id",
    name: "User ID",
  },
  {
    code: "email",
    name: "Email",
  },
];

export const phoneHistoryFilterOptions = [
  {
    code: "user_id",
    name: "User ID",
  },
  {
    code: "phone",
    name: "Phone",
  },
];
